import TenantScreeningServicesPage from './TenantScreeningServicesPage';

export default TenantScreeningServicesPage;
